module.exports = {
  CopyMonthSetting: 'CopyMonth Setting',
  FinanceSetting: 'Finance Setting',
  HrSetting: 'HR Setting',
  MonthlyDataArchive: 'Monthly Data Archive',
  MonthlyFinance: 'Monthly Finance',
  MonthlyHr: 'Monthly HR',
  MonthDataArchive: 'Month Data Archive',
  WeeklyDay: 'Weekly Day',
  SetJudgmentCriteria: 'Set Judgment Criteria',
  ExportingData: 'Exporting data...',
  ExportActualAmountData: 'Export Accpac Writeoff Data',
  ExportInvoiceData: 'Export Accpac Invoice Data',
  ExportBillingData: 'Export Accpac Overseas Billing Data',
  SelectDataWithInvoiceNumber: 'Please select data with invoice number.',
  SelectDataWithBillingNumber: 'Please select data with bill number.'
}
